import React, { useEffect } from 'react';
import { X, CheckCircle, AlertCircle, MessageSquare, Bell } from 'lucide-react';

const NotificationToast = ({ notification, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 5000); // Auto close after 5s
        return () => clearTimeout(timer);
    }, [onClose]);

    const getIcon = () => {
        switch (notification.type) {
            case 'task_assigned': return <CheckCircle size={20} className="text-green-500" />;
            case 'task_completed': return <CheckCircle size={20} className="text-blue-500" />;
            case 'chat_mention': return <MessageSquare size={20} className="text-purple-500" />;
            case 'system_alert': return <AlertCircle size={20} className="text-red-500" />;
            default: return <Bell size={20} className="text-slate-500" />;
        }
    };

    return (
        <div className="fixed top-4 right-4 z-[100] animate-in slide-in-from-right-5 fade-in duration-300">
            <div className="bg-white rounded-xl shadow-2xl border border-slate-100 p-4 w-80 flex items-start gap-3 relative overflow-hidden">
                {/* Accent Bar */}
                <div className={`absolute left-0 top-0 bottom-0 w-1 ${notification.type === 'system_alert' ? 'bg-red-500' : 'bg-blue-500'
                    }`} />

                <div className="mt-0.5">{getIcon()}</div>

                <div className="flex-1 min-w-0">
                    <h4 className="font-bold text-slate-800 text-sm">{notification.title}</h4>
                    <p className="text-slate-600 text-xs mt-1 leading-relaxed line-clamp-2">{notification.message}</p>
                </div>

                <button onClick={onClose} className="text-slate-400 hover:text-slate-600 transition-colors">
                    <X size={16} />
                </button>
            </div>
        </div>
    );
};

export default NotificationToast;
